var data = {
  "body": "<path d=\"M26 11h-6V6a3.64 3.64 0 0 0-3.24-4A3.22 3.22 0 0 0 16 2h-1.57A1.51 1.51 0 0 0 13 3.17v.12l-1 6.34L8.46 15H2v14h19c7.44 0 9-4.35 9-8v-6a3.64 3.64 0 0 0-3.24-4a3.22 3.22 0 0 0-.76 0zM8 27H4V17h4zm20-6c0 4.09-2.22 6-7 6H10V16.3l4-5.93l.73-5.37l.14-1H16c1.44 0 2 .56 2 2v7h8c1.44 0 2 .56 2 2z\" fill=\"currentColor\"/>",
  "width": 32,
  "height": 32
};
export default data;